export enum VerticalCutoutDimensionMode {
  Top = 'Top',
  Bottom = 'Bottom',
}

export enum HorizontalCutoutDimensionMode {
  Hinge = 'Hinge',
  Lock = 'Lock',
}
